import ErrorBoundary from 'Components/ErrorBoundary';
import { Router } from 'Routes';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

interface IAPP {
  msalInstance: PublicClientApplication;
}

function App({ msalInstance }: IAPP) {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <HelmetProvider>
            <Router />
          </HelmetProvider>
        </MsalProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
